import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosShipment, shipmentApiRequest } from "../utils/request";
import { shipmentApis } from "../utils/apis";
import { getUsers } from "../utils/getUser";
import axios from "axios";

export const createShipment = createAsyncThunk(
  "createShipment",
  async (payload) => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.post(
        shipmentApis.createShipment,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateShipment = createAsyncThunk(
  "updateShipment",
  async (payload) => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.post(
        shipmentApis.updateShipment,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getAllShipmentDetail = createAsyncThunk(
  "getAllShipmentDetail",
  async (payload) => {
    try {
      const axiosInstance = createAxiosShipment();
      const params = new URLSearchParams();

      // Add basic params
      params.append("skip", payload?.skip);
      params.append("limit", payload?.limit);

      // Add each status separately
      if (Array.isArray(payload?.shipment_status)) {
        payload?.shipment_status.forEach((status) => {
          params.append("shipment_status", status);
        });
      }

      // Add each type separately
      if (Array.isArray(payload?.shipment_type)) {
        payload?.shipment_type.forEach((type) => {
          params.append("shipment_type", type);
        });
      }
      if (payload?.search) {
        params.append("search", payload?.search);
      }
      if (payload?.sort_order) {
        params.append("sort_by", payload?.sort_by);
        params.append("sort_order", payload?.sort_order);
      }
      // const response = await axiosInstance.get(shipmentApis.getAllShipment);
      const response = await axiosInstance.get(
        `${shipmentApis?.getAllShipment}?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getShipmentBYItemId = createAsyncThunk(
  "getShipmentBYItemId",
  async (payload) => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.get(
        `${shipmentApis.getShipmentBYItemId}/${payload}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const syncShipmentWithWMS = createAsyncThunk(
  "syncShipmentWithWMS",
  async (payload) => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.get(
        `${shipmentApis.syncShipmentWithWMS}/${payload}/sync_wms`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getShipmentTrackingBYItemId = createAsyncThunk(
  "getShipmentTrackingBYItemId",
  async (payload) => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.get(
        `${shipmentApis.getTrackingDetailsById}/${payload?.id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const uploadShipmentDoc = createAsyncThunk(
  "uploadShipmentDoc",
  async ({ payload, docFormData }) => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.post(
        `${shipmentApis.uploadShipmentDoc}?id=${payload.itemId}&document_type=${payload.docType}`,
        docFormData,
        {
          headers: {
            Authorization: `Bearer ${getUsers()?.access_token}`,
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const downloadShipmentDoc = createAsyncThunk(
  "downloadShipmentDoc",
  async (payload) => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.get(
        `${shipmentApis.downloadShipmentDoc}?id=${payload.id}&document_type=${payload.docType}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getInvoiceDetails = createAsyncThunk(
  "getInvoiceDetails",
  async (payload) => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.get(
        `${shipmentApis.getInvoiceDetails}?id=${payload.id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);
export const validateShipmentDetails = createAsyncThunk(
  "validateShipmentDetails",
  async (payload) => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.get(
        `${shipmentApis.validateShipmentDetails}?walmart_shipping_id=${payload.id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateShipmentTracking = createAsyncThunk(
  "updateShipmentTracking",
  async (payload) => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.post(
        shipmentApis.updateShipmentTracking,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const retryFailedShipmentTracking = createAsyncThunk(
  "retryShipmentTracking",
  async () => {
    try {
      const axiosInstance = createAxiosShipment();
      const response = await axiosInstance.post(
        `${shipmentApis.retryShipmentTracking}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

const ShipmentSlice = createSlice({
  name: "shipment",
  initialState: {
    orderSlice: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(createShipment.pending, (state) => {
        state.loading = true;
      })
      .addCase(createShipment.fulfilled, (state, action) => {
        state.loading = false;
        state.shipmentSlice = action.payload;
      })
      .addCase(createShipment.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default ShipmentSlice.reducer;
